{
	"itemsAcrossTopics": "{{itemCount}} items across {{topicCount}} topics",
	"language": {
		"select": "Select language",
		"display": "Display language",
		"english": "English",
		"chinese": "Chinese",
		"japanese": "Japanese",
		"switchedMessage": "Language switched from {{from}} to {{to}}",
		"currentLanguage": "Your current language is {{langname}}",
		"switchLanguage": "Switch language",
		"switchTo": "Switch to {{language}}",
		"sectionTitle": "Language"
	},
	"dashboard": {
		"header": {
			"title": "Home",
			"quickStudy": "Quick study"
		},
		"reviewPrompt": {
			"buttons": {
				"couldBeBetter": "Could be better",
				"itsAwesome": "It's awesome"
			},
			"title": "You're on a roll!",
			"body": "We're thrilled to see your dedication to studying! How's your experience with the app so far? Would you mind sharing your thoughts with a review?",
			"cta": "May be later"
		},
		"actions": {
			"studyWeak": "Focus on weak areas",
			"viewProgress": "See your progress",
			"seeRank": "Check your rank",
			"seeRankings": "View leaderboard",
			"unlock": "Unlock premium content",
			"unlockTooltip": "Gain access to exclusive features and advanced study materials by unlocking premium content",
			"startCustomSession": "Create a custom session",
			"startCustomSessionTooltip": "Start a custom study session to focus on specific areas of your study",
			"takeDiagnostic": "Take diagnostic",
			"takeDiagnosticTooltip": "Take a diagnostic to assess your current level and tailor your study plan accordingly",
			"viewDiagnostic": "View diagnostic results",
			"viewDiagnosticTooltip": "View your diagnostic results to see your strengths and areas for improvement",
			"viewPodcasts": "Listen to podcasts",
			"viewPodcastsTooltip": "Access educational podcasts to enhance your learning experience",
			"upgradeToPremium": "Go premium",
			"upgradeToPremiumTooltip": "Upgrade to premium to access all content and features",
			"extendAccess": "Extend access",
			"extendAccessTooltip": "Extend your access to premium content and features",
			"setExamDate": "Set test date",
			"setExamDateTooltip": "Set your test date to track your progress and prepare for your test"
		},
		"stats": {
			"mastery": "Mastery",
			"masteryValue": "{{value}}%",
			"completed": "Completed",
			"completedValue": "{{count}} items",
			"xpEarned": "Earned",
			"xpEarnedValue": "{{value}} XP",
			"accuracy": "Accuracy",
			"accuracyValue": "{{value}}%",
			"untilExam": "Until test",
			"examDate": "Test date",
			"daysLeft": "{{count}} days",
			"pastDue": "Past due",
			"setExamDate": "Set date"
		},
		"menu": {
			"store": "Store",
			"settings": "Settings"
		},
		"diagnostics": {
			"title": "Diagnostics",
			"free": "Free",
			"Reading & Listening": "Reading & Listening",
			"Speaking & Writing": "Speaking & Writing",
			"duration": "{{count}} {{item}} • {{minutes}} mins",
			"completed": "{{count}} {{item}} completed",
			"start": "Start",
			"viewReport": "View report"
		},
		"skills": {
			"title": "Skills",
			"Reading": "Reading",
			"Listening": "Listening",
			"Speaking": "Speaking",
			"Writing": "Writing"
		},
		"search": {
			"placeholder": "Find anything..."
		}
	},
	"appbar": {
		"progress": {
			"title": "Progress",
			"description": "See your performance and where to improve."
		},
		"leaderboard": {
			"title": "Leaderboard",
			"description": "See how you stack up against others"
		},
		"home": {
			"title": "Home",
			"subtitle": "Your dashboard"
		},
		"podcasts": {
			"title": "Podcasts",
			"description": "Listen to expert-led orthopedic podcasts."
		}
	},
	"emptyState": {
		"leaderboard": {
			"title": "No leaders yet",
			"subtitle": "We're still collecting data. Try studying and come back later to see how you stack up!"
		},
		"progress": {
			"title": "No study progress",
			"subtitle": "As you study your progress will show up here",
			"cta": "Study now"
		}
	},
	"errors": {
		"sessionCreation": {
			"title": "Error",
			"body": "Session creation failed, please try again"
		}
	},
	"mastery": {
		"labels": {
			"advanced": "Advanced",
			"highIntermediate": "Intermediate",
			"basic": "Basic",
			"none": "Not answered",
			"high": "Mastered",
			"medium": "Almost there",
			"low": "Needs work"
		}
	},
	"leaderboard": {
		"resetIn": "Leaderboard resets in {{days}} days",
		"periods": {
			"all_time": "All time",
			"month": "This month",
			"week": "This week"
		}
	},
	"sessionConfig": {
		"title": "Study session",
		"diagnostic": "Diagnostic",
		"skill": "Skill",
		"mastery": "Mastery",
		"setCount": "{{count}} {{type}}",
		"dismiss": "Ok",
		"status": {
			"notAnswered": "Not answered",
			"needsWork": "Needs work"
		},
		"itemCount": "You will complete {{count}} items across {{topics}}",
		"start": "Start",
		"configuringSession": "Configuring session",
		"fetchingContent": "Fetching content",
		"preparingMaterials": "Preparing materials",
		"almostThere": "Almost there",
		"startingSession": "Starting session",
		"playIcon": "play-outline",
		"infoText": "You'll complete **{{numItems}}** {{itemCount}}. This will take about **{{timeString}}**."
	},
	"premium": {
		"chip": "Premium",
		"tooltip": "Premium content",
		"upgrade": "Upgrade to premium"
	},
	"purchase": {
		"success": {
			"headerTitle": "Thank you for your purchase!",
			"subtitle": "Your Purchase was successful",
			"accessGranted": "Access to your {{name}} has been successfully granted",
			"purchaseSuccessful": "Your {{name}} Purchase was successful",
			"studyPack": "Study-Pack",
			"practiceTest": "Practice Test",
			"documentTitle": "Purchase"
		},
		"paywall": {
			"studyPackDialogTitle": "Upgrade your study plan",
			"defaultDialogTitle": "Upgrade your study plan",
			"practiceTestDialogTitle": "Unlock practice tests",
			"title": "Unlock all items and maximize your test readiness {{date}}",
			"beforeDate": "before {{date}}",
			"accessHere": "Access here",
			"accesDuration": {
				"yearPlan": "The **{{duration}} {{interval}}** plan provides extended access, giving you maximum flexibility to study at your own pace and thoroughly prepare for your test.",
				"moreTime": "If you think you'll need more time to study, you can consider the **{{yearPlanDuration}} {{yearPlanInterval}}** plan.",
				"otherPlan": "The **{{duration}} {{interval}}** plan will grant you access until **{{expiryText}}**, which gives you enough time to study. {{moreTime}}"
			},
			"purchaseDisclaimer": "On confirmation of purchase you will be granted full access to the content of this product for the duration selected. When this period expires, you will lose access to the restricted content. If you wish to extend your access for any reason (e.g. you moved your test date), you can add time via additional in-app purchases. For more information, see our [Terms of Service and Privacy Policy]({{tosLink}}).",
			"recommendedPlan": "We recommend the **{{duration}} {{interval}}** plan to best prepare for your test {{dateText}}"
		}
	},
	"learningModes": {
		"questions": "Questions",
		"reading": "Reading",
		"listening": "Listening",
		"writing": "Writing",
		"speaking": "Speaking",
		"readingListening": "Reading & Listening",
		"speakingWriting": "Speaking & Writing"
	},
	"progress": {
		"tagProgress": {
			"subtitle": "Based on {{numItems}} {{item}} attempted across {{count}} {{type}}",
			"itemCount": "{{count}} {{item}}",
			"tooltip": "This shows your progress across {{count}} {{type}}. It's based on {{itemCount}} {{item}} you've attempted so far."
		},
		"itemTypeProgress": {
			"title": "Performance by item type",
			"subtitle": "Based on {{count}} {{item}}",
			"tooltip": "This shows your performance across {{count}} {{type}}"
		},
		"needsImprovement": {
			"title": "Needs improvement",
			"subtitle": "Recommended {{type}} for you to improve upon",
			"cta": "Study now"
		},
		"mastery": {
			"high": "Mastered",
			"medium": "Almost there",
			"low": "Needs work",
			"count": "{{count}} {{item}} attempted",
			"highTooltip": "You've mastered {{count}} {{item}}",
			"mediumTooltip": "You're making progress on {{count}} {{item}}",
			"lowTooltip": "You need more practice with {{count}} {{item}}"
		},
		"stats": {
			"completion": "Completion",
			"completionCount": "{{completed}}/{{total}} {{item}}",
			"completionTooltip": "You've completed {{completed}} out of {{total}} {{item}}"
		},
		"summary": {
			"title": "Learning summary",
			"subtitle": "Based on {{count}} {{item}} attempted",
			"tooltip": "This summary shows your mastery levels and completion progress across {{count}} total {{item}}. Your performance is measured through practice sessions, assessments, and study activities.",
			"mastery": "Mastery",
			"quickStats": "Quick stats"
		},
		"practiceTests": {
			"performanceTooltip": "Your estimated performance is {{score}}%",
			"estimatedPerformance": "Estimated performance"
		}
	},
	"auth": {
		"incorrectPasscode": "Incorrect passcode",
		"verify": {
			"openEmail": "Open email to continue",
			"signInCta": "Verifying your account...",
			"signUpCta": "Creating your account...",
			"contactSupport": "Can’t see the email? Check your spam folder or",
			"contactSupportLink": "Contact us",
			"resendMagicLink": "Resend magic link",
			"resendMagicLinkIn": "Resend magic link in {{time}}",
			"signInBody": "You're almost there! Verifying your details to securely sign in to the {{appName}} app.",
			"signUpBody": "Almost done! We're verifying your details to create your new {{appName}} app account.",
			"magicLinkEmail": "We've sent a magic link to **{{email}}**\nClick the link in your email to securely sign in.",
			"magicLinkEmailExpiry": "This link expires in 10 minutes",
			"confirmEmail": "Confirm your email",
			"redirectingToApp": "Redirecting to the {{appName}} app...",
			"appNotOpen": "App did not open? Click the button below to open the associated application",
			"openApp": "Open {{appName}} app",
			"installAppPrompt": "If nothing happens, make sure you have the {{appName}} app installed on your device",
			"verifyAccountTitle": "Verify your account",
			"emailResent": "Magic link sent to {{email}}\nPlease check your inbox, including spam.",
			"verificationLinkExpired": "Verification link expired",
			"verificationLinkExpiredBody": "Verification links expire after 10 minutes and can only be used once. \nYou can request a new one by logging in again",
			"loginAgain": "Login again",
			"contactSupportExpiredLink": "If this issue continues to persist, let us know"
		}
	},
	"onboarding": {
		"steps": {
			"welcome": {
				"title": "Welcome to the TOEFL Practice!",
				"description": "The official AI coach for the TOEFL iBT",
				"cta": "Get Started",
				"bottomLabelMobile": "Let us custom-tailor your study plan and show you how to use your AI coach effectively"
			},
			"goal": {
				"title": "What's your goal?",
				"description": "Choose what best describes your goal with the TOEFL iBT",
				"cta": "Continue"
			},
			"testDate": {
				"title": "Set your test date",
				"description": "We'll send reminders and tailor your study plan based on your known or estimated test date",
				"cta": "Continue",
				"bottomLabel": "You can always change this later."
			},
			"skills": {
				"title": "Here's how it works",
				"description": "The TOEFL iBT tests you on four core skills: reading, listening, speaking, and writing",
				"cta": "Start",
				"bottomLabel": "Walk through a quick demo to learn how to use some of this app's core features"
			},
			"features": {
				"title": "You're ready to go!",
				"description": "Here's what you learned:",
				"descriptionMobile": "Here's what you can do in the app:",
				"cta": "Start diagnostic",
				"secondaryCta": "Go to home",
				"bottomLabel": "Browse the app or start your FREE diagnostic now"
			},
			"chooseContext": {
				"title": "Choose your exam",
				"description": "Which specific exam are you preparing for?",
				"cta": "Continue"
			},
			"chooseCategory": {
				"title": "Choose your category",
				"description": "Which type of exam are you preparing for?",
				"cta": "Continue"
			}
		},
		"goals": {
			"firstTime": {
				"label": "First-time test taker",
				"description": "I'm taking the test for the first time"
			},
			"retaking": {
				"label": "Retaking the test",
				"description": "I'm retaking the test in order to improve my scores"
			},
			"exploring": {
				"label": "Just exploring",
				"description": "I want to become more familiar with the test and assess my readiness"
			}
		},
		"actions": {
			"skip": "Skip"
		},
		"features": {
			"confidence": {
				"label": "Set your confidence to track progress",
				"description": "This will help the app learn from you and provide a more personalized experience"
			},
			"verified": {
				"label": "Submit answers to get feedback",
				"description": "The TOEFL AI will generate personalized feedback tailored to your specific responses"
			},
			"assistant": {
				"label": "Ask your AI learning assistant",
				"description": "Dig deeper into each item and learn how to improve your skills"
			}
		},
		"skills": {
			"reading": "Reading",
			"listening": "Listening",
			"speaking": "Speaking",
			"writing": "Writing"
		}
	},
	"account": {
		"title": "Account settings",
		"subtitle": "Manage your account settings",
		"currentExam": "Current test",
		"examDate": "Test date",
		"selectDate": "Select date",
		"appearance": "Appearance",
		"features": "Features",
		"audioPlaybackTest": "Show test audio playback dialog",
		"darkMode": "Dark mode",
		"accountInfo": "Account",
		"name": "Name",
		"email": "Email",
		"dev": "Dev",
		"sandbox": "Sandbox",
		"about": "About",
		"termsOfService": "Terms of service",
		"privacyPolicy": "Privacy policy",
		"aiToolsTos": "AI tools terms of use",
		"support": "Support",
		"supportEmailBody": "I am reaching out to you because I need assistance with [  ]\n\n\n\nHere is some helpful information to help resolve things faster: \n\nUsername associated with the account (found in settings when logged into the app):\n{{username}}\n\nEmail associated with my order (found in settings when logged into the app):\n{{email}}\n\nOrder Number (usually found in the receipt email that triggered upon purchase):\n\nIs there a chance a different name or email was used when the product was actually purchased? If so please provide them:\n\nFirst and last name:\n\nEmail:",
		"contactSupport": "Contact support",
		"signOut": "Sign out",
		"signOutConfirmation": "Are you sure you want to sign out?",
		"deleteAccount": "Delete account",
		"platform": "Platform",
		"partnerships": "Partnerships",
		"validUntil": "Expires on {{date}}",
		"extendValidity": "Extend access",
		"frequentlyAskedQuestions": "Frequently asked questions"
	},
	"common": {
		"on": "on",
		"topic": "topic",
		"itemCount": "{{count}} items",
		"item": "item",
		"items": "items",
		"and": "and",
		"this": "this",
		"of": "of",
		"knowMore": "Know more",
		"proficiency": "proficiency",
		"didNotAnswer": "Items that you have not yet attempted",
		"notAnswered": "Not answered",
		"attempted": "attempted",
		"attempt": "attempt",
		"activity": "activity",
		"performance": "Performance",
		"estimatedProficiency": "Estimated proficiency",
		"details": "details",
		"keepPracticing": "keep practicing!",
		"leaveFeedback": "Leave feedback",
		"copiedToClipboard": "Copied to clipboard",
		"eg": "e.g.",
		"set": "set",
		"hint": "hint",
		"itemType": "item type",
		"minute": "minute",
		"minutes": "{{count}} minutes",
		"hour": "hour",
		"hours": "{{count}} hours",
		"continue": "Continue",
		"unlock": "Unlock",
		"cancel": "Cancel",
		"ok": "Ok",
		"yes": "Yes",
		"free": "Free",
		"correct": "Correct",
		"incorrect": "Incorrect",
		"marked": "Marked",
		"skipped": "Skipped",
		"skill": "skill",
		"word": "word",
		"submitResponse": "Submit response",
		"viewDetails": "View details",
		"sec": "sec",
		"week": "Week",
		"month": "Month",
		"year": "Year",
		"day": "Day",
		"selectTestDate": "Select test date",
		"points": "Points"
	},
	"session": {
		"attributes": {
			"stimulus": "stimulus"
		},
		"stimulusTypes": {
			"reading": "Reading",
			"listening": "Listening",
			"speaking": "Speaking",
			"writing": "Writing",
			"image": "Image"
		},
		"masteryLevels": {
			"belowBasic": "Below Basic",
			"basic": "Basic",
			"belowLowIntermediate": "Below Low-Intermediate",
			"lowIntermediate": "Low-Intermediate",
			"highIntermediate": "High-Intermediate",
			"advanced": "Advanced",
			"proficiencySubtitle": "On the {{trademark}}, this maps to a score of **{{minScore}}-{{maxScore}}/30**",
			"infoSectionLabel": "{{skill}} section info",
			"infoSectionText": {
				"Reading": "The {{trademark}} Reading section assesses how well you can read and understand written materials used in an academic environment. It includes two reading passages, each approximately 700 words long, with 10 questions per passage. It should take about 35 minutes to complete the Reading section.",
				"Listening": "The {{trademark}} Listening section is designed to measure your ability to understand conversations and lectures in English. It includes listening for: basic comprehension, understanding the speaker's attitude and degree of certainty, and connecting information. It should take about 36 minutes to complete the Listening section.",
				"Speaking": "The {{trademark}} Speaking section measures your ability to speak English effectively in academic settings. The four questions/tasks resemble real-life situations you might encounter both in and outside of a classroom. It should take about 16 minutes to complete the Speaking section.",
				"Writing": "The {{trademark}} test Writing section measures your ability to write in English in an academic setting, and to present your ideas in a clear, well-organized way. You'll type your responses on a computer keyboard and it should take about 29 minutes to complete the Writing section."
			}
		},
		"itemTypes": {
			"MCSS": "Multiple choice single select",
			"MCSSH": "Multiple choice single select highlight",
			"MCMS": "Multiple choice multiple select",
			"MCMSH": "Multiple choice multiple select highlight",
			"INSERT_TEXT": "Insert text",
			"MATCH_MS": "Match multiple select",
			"MCSSM": "Multiple choice single select match",
			"MCMSM": "Multiple choice multiple select match",
			"MCGS": "Multiple choice gap select",
			"MCOS": "Multiple choice order select",
			"LISTENING_REPLAY": "Listening replay",
			"AUDIO_INPUT": "Audio input",
			"ACADEMIC_DISCUSSION_RESPONSE": "Academic discussion response",
			"INTEGRATED_WRITING_RESPONSE": "Integrated writing response"
		},
		"passageStem": {
			"item": "Item",
			"of": "of",
			"passage": "Passage",
			"lecture": "Lecture",
			"professorsQuestion": "Professor's Question",
			"listen": "Listen",
			"openPassage": "Open Passage",
			"notYetInserted": "Not yet inserted",
			"insertedAtPosition": "Inserted at position #{{position}}"
		},
		"hint": {
			"show": "Show hint"
		},
		"navigation": {
			"next": "Next",
			"previous": "Prev",
			"skip": "Skip",
			"finish": "Finish",
			"help": "Help"
		},
		"stats": {
			"skill": "Skill",
			"answered": "Answered",
			"speed": "Speed",
			"response": "Response",
			"confidence": "Confidence",
			"pointsEarned": "Points earned",
			"word": "Word",
			"words": "Words",
			"time_taken": "{{time}} {{sec}}",
			"time_taken_tooltip": "It took you {{time_taken}} seconds to read and respond to this item{{end}}",
			"time_taken_tooltip_end": ", including this {{stimulus_type}} stimulus"
		},
		"explanation": {
			"title": "Explanation",
			"feedback": "Feedback"
		},
		"followUps": "Follow-ups",
		"suggestCorrection": "Suggest correction",
		"answer": {
			"correct": "Correct",
			"incorrect": "Incorrect",
			"skipped": "Skipped"
		},
		"confidence": {
			"high": "High",
			"medium": "Medium",
			"low": "Low"
		},
		"endDialog": {
			"title": "Finish session early?",
			"confirmEndDiagnostic": "Are you sure you want to end your session? All progress will be lost and you'll need to start over.",
			"confirmEnd": "You still have {{num}} {{itemLabel}} left. You can finish now or keep studying to complete them.",
			"confirmEndNoAnswer": "You haven’t answered any questions yet. Are you sure you want to finish now?",
			"confirmEndNoAnswerPositive": "Keep studying",
			"confirmEndNoAnswerNegative": "Finish now"
		},
		"permissionDialog": {
			"title": "Allow microphone",
			"descriptionWeb": "To record your voice, we need to access the microphone. Click the icon to the left of the URL bar, and enable microphone permission.",
			"descriptionMobile": "To record your voice, we require access to your microphone. Please enable microphone permissions in your device settings.",
			"ok": "Ok",
			"cancel": "Cancel",
			"openSettings": "Open settings"
		},
		"audioPlaybackTestDialog": {
			"title": "Test audio playback",
			"description": "The {{appName}} app includes multiple audio playback features, such as those in stimuli, test items, and text-to-speech. To ensure the best experience, please test your audio below. Once you've confirmed it's working, proceed.",
			"troubleshooting": {
				"title": "Troubleshooting audio issues",
				"volumeTitle": "Check device volume",
				"volumeDescriptionWeb": "Adjust volume using keyboard controls or system volume settings in menu/taskbar",
				"volumeDescriptionMobile": "Use device volume buttons or adjust in system settings",
				"outputTitle": "Verify audio output device",
				"outputDescription": "In case of headphones, ensure they are properly connected and selected as the active output device",
				"browserTitle": "Check browser tab audio",
				"browserDescription": "Look for muted speaker icon next to tab title and unmute if present."
			},
			"skipCheck": "Skip this check next time",
			"workingButton": "CONFIRM AUDIO",
			"textToHear": "You should hear: {{text}}"
		},
		"overall": "Overall",
		"feedback": {
			"greatJob": "Great job!",
			"niceWork": "Nice work!",
			"wellDone": "Well done!",
			"excellent": "Excellent!",
			"outstanding": "Outstanding!",
			"fantastic": "Fantastic!",
			"brilliant": "Brilliant!",
			"amazingWork": "Amazing work!",
			"superb": "Superb!",
			"wayToGo": "Way to go!",
			"perfect": "Perfect!",
			"impressive": "Impressive!",
			"stellarWork": "Stellar work!",
			"awesomeJob": "Awesome job!",
			"excellentEffort": "Excellent effort!",
			"remarkable": "Remarkable!",
			"youNailedIt": "You nailed it!",
			"terrificWork": "Terrific work!",
			"negative": {
				"hangIn": "Hang in there",
				"youCanDoIt": "You can do it",
				"keepTrying": "Keep trying",
				"persistenceKey": "Persistence is key",
				"practiceMakesPerfect": "Practice makes perfect",
				"keepGoingStrong": "Keep going strong"
			}
		},
		"subskills": {
			"content": {
				"title": "Content",
				"integratedWriting": "Your response should accurately present key points from the lecture and connect them to the reading. Avoid significant omissions, inaccuracies, or misrepresentation of ideas from either source.",
				"academicDiscussionWriting": "Your response should directly respond to the professor's question or class discussion topic. Provide a relevant viewpoint or opinion, supported by examples, personal experiences, or logical reasoning. Stay on topic and contribute meaningfully to the discussion.",
				"integratedSpeaking": "Accurately summarize or synthesize the key points from the listening passage (and reading, if included). Make clear connections between the sources (e.g., how the lecture counters or supports the reading). Avoid major omissions or misrepresentations of the content.",
				"independentSpeaking": "Fully address the prompt by stating a clear personal opinion or choice, and support it with adequate reasons and examples. Keep the content relevant and focused, ensuring your response is directly connected to the question."
			},
			"languageUse": {
				"title": "Language Use",
				"integratedWriting": "Your response should use accurate grammar, appropriate vocabulary, and clear sentence structure. Minor errors are acceptable as long as they do not obscure meaning or disrupt the flow.",
				"academicDiscussionWriting": "Demonstrate clear and concise writing that uses appropriate academic language for a class forum. Basic grammar and sentence structures should be correct, with any errors remaining minimal so they do not impede clarity. Aim for vocabulary that conveys your points accurately while maintaining a natural tone for a discussion setting.",
				"integratedSpeaking": "Use grammatically accurate sentences and vocabulary that convey the necessary information. Minor slips are acceptable, but they should not cause confusion or frequent rephrasing. Show enough command of structures and words to express the relationships among the ideas from the sources effectively.",
				"independentSpeaking": "Employ vocabulary and grammar accurately to convey your thoughts. While small mistakes are permissible, they should not significantly disrupt the flow or clarity of your response. Aim for varied sentence structures that support coherent, fluent speech."
			},
			"organizationAndDevelopment": {
				"title": "Organization and Development",
				"integratedWriting": "Your response should be well-organized with a clear introduction, body, and conclusion. Use logical transitions and sufficiently develop ideas to support your argument effectively.",
				"academicDiscussionWriting": "Compose a brief but coherent response, structuring your statements so that each idea builds on the last. Even in a short post, include a concise introduction (stating your stance), a body (supporting it with reasons or examples), and a succinct conclusion or wrap-up. Make logical connections between your points so classmates can follow your argument easily."
			},
			"topicDevelopment": {
				"title": "Topic Development",
				"integratedSpeaking": "Accurately summarize or synthesize the key points from the listening passage (and reading, if included). Make clear connections between the sources (e.g., how the lecture counters or supports the reading). Avoid major omissions or misrepresentations of the content.",
				"independentSpeaking": "Fully address the prompt by stating a clear personal opinion or choice, and support it with adequate reasons and examples. Keep the content relevant and focused, ensuring your response is directly connected to the question."
			},
			"delivery": {
				"title": "Delivery",
				"integratedSpeaking": "Speak in a clear, naturally paced manner with proper pronunciation and intonation. Occasional pauses, slight mispronunciations, or minor pacing issues can happen but should not impede overall comprehension. Your response should be easy for a listener to follow.",
				"independentSpeaking": "Speak naturally, maintaining appropriate volume and pace. Pronunciation and intonation should be clear enough that a listener can easily understand you. Occasional minor errors or hesitations should not disrupt comprehension."
			}
		},
		"aiStates": {
			"processingAudio": "Processing audio...",
			"analyzingSpeech": "Analyzing your speech...",
			"gradingResponse": "Grading your response...",
			"generatingFeedback": "Generating feedback...",
			"processingText": "Processing text..."
		}
	},
	"report": {
		"productName": "{{examName}} {{type}}",
		"practiceTests": "Practice Tests",
		"studyPack": "Study-Pack",
		"diagnosticCompleted": "Diagnostic assessment completed",
		"practiceTestCompleted": "Practice test completed",
		"studySessionCompleted": "Study session completed",
		"diagnosticSessionCompleted": "Diagnostic session completed",
		"answered": "Answered",
		"answeredTooltip": "How many questions you've answered",
		"correct": "Correct",
		"correctTooltip": "How many questions you've answered correctly",
		"accuracy": "Accuracy",
		"accuracyTooltip": "Percentage of questions you've answered correctly",
		"duration": "Duration",
		"durationTooltip": "How long you took to complete the test",
		"timeElapsed": "Time elapsed",
		"timeElapsedValue": "{{time}} {{sec}}",
		"timeElapsedTooltip": "How long you took to complete the test",
		"avgSpeed": "AVG SPEED",
		"avgSpeedValue": "{{speed}} {{sec}}",
		"avgSpeedTooltip": "How long you took to answer each question",
		"hintsUsed": "{{hint}} used",
		"hintsUsedTooltip": "Number of hints used in this session",
		"pointsEarned": "Points Earned",
		"pointsEarnedDescription": "You've earned {{numPointsEarned}} out of {{numTotalPoints}} points",
		"stats": {
			"answered": "ANSWERED",
			"time elapsed": "TIME ELAPSED",
			"avg speed": "AVG SPEED",
			"hints used": "HINT USED"
		},
		"pointsInfo": {
			"feedbackText": {
				"advanced": "Fantastic job—keep striving for excellence!",
				"highIntermediate": "You're doing great—keep honing your strengths!",
				"lowIntermediate": "Your progress is steady—keep it up!",
				"basic": "Keep working to boost your abilities!"
			},
			"infoText": "You completed **{{numActivities}} {{activityLabel}}** to practice your {{skillsText}} {{skills}}. {{skillDetails}}. Overall, you earned **{{numPointsEarned}} out of {{numTotalPoints}} points**, suggesting a **{{compositeLevel}} proficiency** across {{thisText}} {{skills}}. {{compositeFeedback}}",
			"infoText.singleSkill": "You completed **{{itemCount}} {{itemLabel}}** focused on your **{{skill_1}}** skill. You scored **{{skill_1_score}} out of {{skill_1_total}}**, indicating a **{{proficiency}}** proficiency. {{compositeFeedback}}",
			"infoText.multiSkill": "You completed **{{itemCount}} {{itemLabel}}**, practicing your **{{skills_text}}** skills. {{skill_details}} Overall, you earned **{{overall_score}} out of {{overall_total}} points**, suggesting a **{{overall_proficiency}}** proficiency across these skills. {{compositeFeedback}}",
			"skillDetails": "In **{{skill}}**, you scored **{{score}} out of {{total}}**, showing a **{{proficiency}}** proficiency."
		},
		"actions": {
			"studyMore": "Study more",
			"reviewAnswers": "Review answers"
		},
		"performance": {
			"title": "Performance",
			"subtitle": "Based on {{count}} items",
			"correct": "Correct",
			"correctItems": "{{count}} items",
			"incorrect": "Incorrect",
			"incorrectItems": "{{count}} items"
		},
		"mastery": {
			"performanceTitle": "Performance",
			"sessionMasteryTitle": "Estimated proficiency",
			"subtitle": "Based on all {{count}} {{item}} from this {{sessionType}}",
			"correct": "Correct",
			"incorrect": "Incorrect",
			"marked": "Marked",
			"skipped": "Skipped"
		},
		"sessionAnalysis": {
			"title": "Session analysis",
			"subtitle": "Personalized analysis and recommendations",
			"viewFullAnalysis": "View analysis",
			"feedbackDialog": {
				"title": "Help us improve this feature",
				"body": "We release updates almost every day and are determined to improve. Would you mind leaving feedback?",
				"placeholder": "Enter your feedback here",
				"cta": "Send feedback",
				"successMessage": "Feedback submitted. Thank you!",
				"feedbackLimitError": "Feedback must be at least 10 characters long"
			},
			"menuActions": {
				"copy": "Copy",
				"altCopy": "Copy summary text",
				"altPositiveFeedback": "This was helpful",
				"altNegativeFeedback": "This could be better",
				"positiveFeedback": "Good response",
				"negativeFeedback": "Bad response",
				"reportIssue": "Report",
				"altReportIssue": "Report this response",
				"emailSummary": "Email summary text",
				"emailAlreadySent": "Email already sent",
				"copiedAnalysis": "Copied analysis to clipboard",
				"emailSent": "Email sent to {{email}}, If you do not receive an email, check your junk, spam, and recently deleted folders",
				"emailFailed": "Failed to send email to {{email}}",
				"emailInstructionMessage": "If you do not receive an email, check your junk, spam, and recently deleted folders, or contact your IT administrator"
			}
		}
	},
	"feedback": {
		"successMessage": "Feedback submitted. Thank you!"
	},
	"dialog": {
		"feedback": {
			"defaultFeedbackBody": "What do you like? What could be improved? We make daily improvements to the platform and our team reads every piece of feedback. Thank you!",
			"title": "Help us improve",
			"body": "We're sorry the app isn't up to your standards and are determined to improve. Would you mind **leaving feedback?**",
			"placeholder": "Enter feedback",
			"cta": "Send feedback"
		},
		"report": {
			"title": "Submit report",
			"body": "Help us understand what’s wrong with this response",
			"cta": "Submit report"
		},
		"faqs": {
			"title": "Frequently asked questions",
			"body": "Here are some of the most frequently asked questions about the app. If you have any other questions, please contact us at support@memorang.ai"
		},
		"delete": {
			"title": "Delete account",
			"placeholder": "Feedback",
			"chooseReason": "Choose Reason",
			"body": "We're sorry to see you go and wish you the best of luck on your academic and professional journey!",
			"options": "Too expensive|Already took my test|Didn't like the content|Missing features/functionality|Other",
			"confirmdelete": {
				"title": "Confirm Account Deletion",
				"cta": "Delete",
				"errorMessage": "Sorry, that email doesn't match this account. Please try again",
				"successMessage": "Account deleted successfully!",
				"validEmail": "Please enter a valid email address"
			}
		},
		"notifyAppLaunch": {
			"title": "Join the mobile app waitlist",
			"body": "The {{appName}} mobile apps are coming soon to iPhone and Android. **They may not be available in all regions initially.** Click below to be the first to be notified when they're available in your region.",
			"cta": "JOIN WAITLIST",
			"successMessage": "You've been added to the waitlist! We'll notify you when the {{appName}} mobile app launches.",
			"failedMessage": "Unable to join the waitlist. Please try again later."
		}
	},
	"encouragements": {
		"positive": {
			"great": "You're doing great!",
			"wellDone": "Well done!",
			"impressive": "Impressive!",
			"amazing": "You are amazing!",
			"awesome": "You are awesome!",
			"onARoll": "You're on a roll!",
			"quitePerformance": "Quite the performance!",
			"fantasticEffort": "Fantastic effort!",
			"keepItUp": "Keep it up!",
			"knowledgeCourses": "Knowledge courses through your veins!"
		},
		"negative": {
			"hangIn": "Hang in there",
			"youCanDoIt": "You can do it",
			"keepTrying": "Keep trying and you'll get there",
			"improvementSteps": "Improvement comes one step at a time",
			"learnFromWrong": "You only learn from wrong answers",
			"persistenceKey": "Persistence is key",
			"practiceMakesPerfect": "Practice makes perfect",
			"keepGoingStrong": "Keep going strong"
		}
	},
	"aila": {
		"askYourOwnQuestion": "Ask your own question"
	},
	"recorder": {
		"tapToRecord": "Tap to record your response",
		"alert": {
			"title": "Max duration reached",
			"body": "The recording has been stopped because it reached the maximum duration of {{maxDuration}} seconds."
		},
		"uiElementPressed": "Recording stopped - stimulus opened during an active recording."
	},
	"writing": {
		"placeholder": "Write your response here...",
		"wordCount": "{{count}} {{word}}",
		"title": "Your response",
		"submit": "Submit"
	},
	"navbar": {
		"home": "Home",
		"progress": "Progress",
		"leaderboard": "Leaders",
		"store": "Store",
		"more": "More",
		"redeem": "Redeem",
		"study-pack": "Study-Pack",
		"podcasts": "Podcasts"
	},
	"tts": {
		"tooltip": "Listen to this text"
	},
	"commandBar": {
		"placeholder": "Find anything...",
		"accessibilityLabel": "Command bar",
		"accessibilityHint": "Activate to search or use commands",
		"actions": {
			"home": "Go to home",
			"progress": "Go to progress",
			"changeTheme": "Change theme",
			"leaderboard": "Go to leaderboard",
			"settings": "Go to settings",
			"premium": "Upgrade to premium",
			"setExamDate": "Set test date",
			"startSession": "Start study session"
		}
	},
	"noInternetAccess": {
		"title": "No internet access",
		"subtitle": "Access to the internet is required to use this app. Please check your WiFi and data settings",
		"retry": "Retry",
		"connectionRestored": "Connection restored! You are back online"
	}
}
